import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=b9d5b6a8&scoped=true&lang=html&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5b6a8",
  null
  
)

export default component.exports